import { type RouteLocationNormalized } from 'vue-router';

export default (to: RouteLocationNormalized): string | undefined => {
  if (to.path !== '/create-password' && to.path !== '/reset-password') return;
  if (to.query.token !== undefined) return;
  return '/login';
};
